import { finish, error } from '../../../modules/banners/actions/upload-banner-image';
import { request as getAllBanners } from '../../../modules/banners/actions/get-all-banners';
import api from '../../../api';

export function request(dispatch, { body }) {
    let {
        bannerId,
        file
    } = body;

    let formData = new FormData();

    formData.set( 'filename', file.name );
    formData.set( 'name', file.name );
    formData.set( 'image', file );

    api.postUpload(`/banners/upload/${bannerId}`, { data: formData })
        .then(resp => {
            dispatch(finish(resp));
            dispatch(getAllBanners());
        }).catch(err => {
            dispatch(error(err));
        });
}
